import { ConfigProvider, notification } from "antd";
import { ReactElement, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-international-phone/style.css";
import "./styles/swiper.scss";
import "./styles/drawer.style.scss";
import "./App.scss";

import "quill/dist/quill.snow.css";
import Login from "./views/login/login";
import instance from "./store/axios";
import LoadingComponent from "./components/loading/loading.component";
import MainPage from "./layout/main-page/main-page";
import CustomerProfile from "./views/customer-profile/customer-profile";
import KycDetails from "./views/kyc-details/kyc-details";
import AddEditDocument from "./views/add-edit-document/add-edit-document";
import EditProfesionalDetails from "./views/edit-professional-details/edit-professional-details";
import EditCommunication from "./views/edit-communication/edit-communication";
import EditPerference from "./views/edit-pereference/edit-preference";
import EditCrs from "./views/edit-crs/edit-crs";
import EditFinancial from "./views/edit-financial/edit-financial";
import EditAccountDetails from "./views/edit-account-details/edit-account-details";
import KycVersions from "./views/kyc-versions/kyc-versions";
import BackendUsers from "./views/backend-users/backend-user";
import { LOGIN, LOGOUT } from "./store/actions";
import axios from "axios";
import UploadCustomers from "./views/upload-customers/upload-customers";
import ViewUploadCustomer from "./views/view-uploaded-customer/view-uploaded-customers";
import TransactionReportIp from "./views/transaction-report-ip/transaction-report-ip";
import ViewExecutedCustomers from "./views/view-executed-customer/view-executed-customers";
import WaitingApprovals from "./views/waiting-approvals/waiting-approvals";
import ReviewForm from "./views/review-form/review-form";
import ViewHistory from "./views/view-history/view-history";
import Countries from "./views/countries/countries";
import States from "./views/states/states";
import Cities from "./views/citeis/cities";
import { Toaster } from "react-hot-toast";
import PortfolioTypes from "./views/portfolio-types/portfolio-types";
import Portfolios from "./views/portfolios/portfolios";
import TakePortfolioAction from "./views/take-portfolio-action/take-portfolio-action";
import Deposit from "./views/deposit/deposit";
import TakeDepositAction from "./views/take-deposit-action/take-deposit-action";
import Redemptions from "./views/redemptions/redemptions";
import Subscription from "./views/subscription/subscription";
import Funds from "./views/funds/funds";
import TakeSubscriptionAction from "./views/take-subscription-action/take-subscription-action";
import Withdrawal from "./views/withdrawal/withdrawal";
import CustomersList from "./views/customers-list/customers-list";
import ClosureRequest from "./views/closure-request/closure-request.component";
import Queries from "./views/queries/queries";
import Rating from "./views/rating/rating";
import News from "./views/news/news";
import EmailTemplates from "./views/email-templates/email-templates";
import AddEditEmailTemplate from "./views/add-edit-email-template/add-edit-email-template";
import Banks from "./views/banks/banks";
import AddEditBank from "./views/add-edit-bank/add-edit-bank";
import EditFund from "./views/edit-fund/edit-fund";
import PaciLogs from "./views/paci-logs/paci-data";
import EditPaciLog from "./views/edit-paci-logs/edit-paci-logs";
import SliderScreen from "./views/slider-screen/slider-screen";
import AddEditPortfolio from "./views/add-edit-portfolio/add-edit-portfolio";
import AddEditSliderScreen from "./views/add-edit-slider-screen/add-edit-slider-screen";
import Notification from "./components/notification/notification";
import Cards from "./views/cards/cards.component";
import AddNotification from "./views/add-notification/add-notification";
import AddCard from "./views/add-card/add-card";
import VerificationCompleted from "./views/verification-completed/verification-completed";
import SomethingWrong from "./views/someting-wrong/something-wrong";
import ExpireLink from "./views/expire-link/expire-link";
import VerificationPassword from "./views/verification-password/verification-password";
import ResetPassword from "./views/reset-password/reset-password";
import EditContactPersons from "./views/edit-contact-persons/edit-contact-persons";
import EditBanks from "./views/edit-banks/edit-banks";
import ChangeList from "./views/change-list/change-list";
import DocumentVersions from "./views/document-versions/document-versions";
import TakeWithdrawalAction from "./views/withdrawal/components/take-withdrawal-action/take-withdrawal-action";
import Knet from "./views/knet/knet";
import TakeRedemptionsAction from "./views/take-redemptions-action/take-redemptions-action";
import CeoDashboard from "./views/ceo-dashboard/ceo-dashboard";
import GoogleAnalytics from "./components/GoogleAnalytics";
import useFcmToken from "./hooks/useFcmHooks";
import firebaseApp from "./utils/firebase.utils";
import { getMessaging, onMessage } from "firebase/messaging";
import AutoInvest from "./views/auto-invest/auto-invest";
import SetNewPassword from "./views/set-new-password/set-new-password";
import CashTransfer from "./views/cash-transfer/cash-transfer";
import TakeCashTransferAction from "./views/cash-transfer/components/take-cash-transfer-action/take-cash-transfer-action";
import CreateCustomerPage from "./views/create-customer/CreateCustomerPage";
import NewKycPage from "./views/new-kyc/NewKycPage";
import OnlineTradingAccess from "./views/online-trading-access/online-trading-access";
import PortfolioAgreementsBulk from "./views/portfolio-agreements-bulk/portfolio-agreements-bulk";
import AgreementReview from "./views/agreement-review/agreement-review";

const App: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state: any) => state?.loading);
  const user = useSelector((state: any) => state?.user);
  const [api, contextHolder]: any = notification.useNotification();
  const { fcmToken, notificationPermissionStatus } = useFcmToken();

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Service Worker registered:", registration);
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const messaging = getMessaging(firebaseApp);
      const unsubscribe = onMessage(messaging, (payload: any) => {
        console.log("Message received. ", payload);

        api.open({
          message: (
            <div className="text-[#14264c] text-sm font-semibold leading-snug tracking-tight">
              {payload.notification.title}
            </div>
          ),
          description: (
            <div className="flex flex-col gap-3 h-fit">
              <div className=" text-[#212427] text-xs font-normal leading-tight">
                {payload.notification.body}
              </div>
              {payload.data.link && (
                <div className="flex justify-end">
                  <a
                    href={payload?.data?.link}
                    target="_blank"
                    className=" text-white bg-blue-500 px-3 py-2 cursor-pointer rounded-md text-xs font-normal leading-tight"
                  >
                    Show details
                  </a>
                </div>
              )}
              <div className="w-full flex justify-center items-center">
                <img src={payload.data.image} />
              </div>
            </div>
          ),
          placement: "topRight",
          duration: 10000000,
          icon: (
            <div className="h-8 p-2 bg-[#002f6c] rounded justify-start items-start gap-1.5 inline-flex">
              <img src="/images/logo.svg" alt="kamco" title="kamco" />
            </div>
          ),
          style: {
            padding: "15px",
            borderRadius: "8px",
            backgroundColor: "#e1dfd9",
            boxShadow:
              "0px 0px 1px 0px rgba(0, 0, 0, 0.10), 0px 2px 10px 0px rgba(0, 0, 0, 0.30)",
          },
        });
      });
      return () => {
        unsubscribe();
      };
    }
  }, []);

  if (user?.accessToken) {
    instance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${user?.accessToken}`;
  }

  if (user?.branches) {
    instance.defaults.headers.common["branch"] = localStorage.getItem(
      "selectedBranches"
    )
      ? JSON.parse(localStorage.getItem("selectedBranches") || "{}")
      : null;
  }

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_ENDPOINT_VERSION}/auth/refresh`,
            {
              refreshToken: JSON.parse(
                localStorage.getItem("star_user") as string
              )?.refreshToken,
            }
          );
          instance.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.data?.accessToken}`;
          originalRequest.headers.Authorization = `Bearer ${response.data.data.accessToken}`;
          dispatch({
            type: LOGIN,
            payload: {
              user: response?.data?.data,
            },
          });
          localStorage.setItem(
            "star_user",
            JSON.stringify(response.data?.data)
          );
          return instance(originalRequest);
        } catch (error: any) {
          dispatch({ type: LOGOUT });
        }
      }
      return Promise.reject(error);
    }
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0A3677",
        },
      }}
    >
      <div className="App">
        <GoogleAnalytics />
        {contextHolder}
        {loadingState && <LoadingComponent />}
        {/* <Notification /> */}
        <Toaster
          toastOptions={{
            success: {
              style: {
                background: "#3ccc65",
                color: "white",
              },
              iconTheme: {
                primary: "white",
                secondary: "#3ccc65",
              },
            },
            error: {
              style: {
                background: "#e3256c",
                color: "white",
              },
              iconTheme: {
                primary: "white",
                secondary: "#e3256c",
              },
            },
          }}
        />
        <Routes>
          {!user?.accessToken ? (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/set-new-password" element={<SetNewPassword />} />
              <Route
                path="/verification-completed"
                element={<VerificationCompleted />}
              />
              <Route
                path="/verification-phone"
                element={<VerificationPassword />}
              />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/something-wrong" element={<SomethingWrong />} />
              <Route path="/expire-link" element={<ExpireLink />} />
              <Route path="/knet" element={<Knet />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/home" element={<MainPage />}>
                <Route index element={<CeoDashboard />} />
                <Route
                  index
                  path="create-customer"
                  element={<CreateCustomerPage />}
                />
                <Route
                  index
                  path="customers-list"
                  element={<CustomersList />}
                />
                <Route
                  path="customer-profile/:customerId"
                  element={<CustomerProfile />}
                />
                <Route
                  path="new-kyc/:accountId/:activeKyc"
                  element={<NewKycPage />}
                />
                <Route
                  path="business-account/:accountId/:activeKyc/details"
                  element={<KycDetails />}
                />
                <Route
                  path="business-account/:accountId/:activeKyc/:reviewId/:documentId/details"
                  element={<KycDetails />}
                />
                <Route
                  index
                  path="closure-requests"
                  element={<ClosureRequest />}
                />
              </Route>
              <Route path="/customers" element={<MainPage />}>
                <Route index path="upload" element={<UploadCustomers />} />
                <Route index path="view/:id" element={<ViewUploadCustomer />} />
                <Route
                  index
                  path="transaction-report-ip"
                  element={<TransactionReportIp />}
                />
                <Route
                  index
                  path="execute"
                  element={<ViewExecutedCustomers />}
                />
                <Route
                  index
                  path="waiting-approvals"
                  element={<WaitingApprovals />}
                />
                <Route
                  index
                  path="online-trade-access"
                  element={<OnlineTradingAccess />}
                />
                <Route
                  index
                  path="review-form/:accountId/:kycId/:reviewId"
                  element={<ReviewForm />}
                />
                <Route
                  index
                  path="view-history/:kycReviewId"
                  element={<ViewHistory />}
                />
                <Route
                  index
                  path="change-list/:accountId/:kycId"
                  element={<ChangeList />}
                />
              </Route>
              <Route path="/countries" element={<MainPage />}>
                <Route index path="" element={<Countries />} />
              </Route>
              <Route path="/portfolio" element={<MainPage />}>
                <Route index path="" element={<Portfolios />} />
                <Route path="types" element={<PortfolioTypes />} />
                <Route
                  path="edit-portfolio/:portfolioId"
                  element={<AddEditPortfolio />}
                />
                <Route path="add-portfolio" element={<AddEditPortfolio />} />
                <Route
                  path="agreement-review/:agreementId"
                  element={<AgreementReview />}
                />
                <Route
                  path="agreements-bulk"
                  element={<PortfolioAgreementsBulk />}
                />
                <Route
                  path="take-action/:portfolioId"
                  element={<TakePortfolioAction />}
                />
              </Route>
              <Route path="/deposit" element={<MainPage />}>
                <Route index path="" element={<Deposit />} />
                <Route
                  path="take-action/:depositId"
                  element={<TakeDepositAction />}
                />
              </Route>
              <Route path="/funds" element={<MainPage />}>
                <Route index path="" element={<Funds />} />
                <Route path="edit-fund/:fundId" element={<EditFund />} />
              </Route>
              <Route path="/news" element={<MainPage />}>
                <Route index path="" element={<News />} />
              </Route>
              <Route path="/cards" element={<MainPage />}>
                <Route index path="" element={<Cards />} />
                <Route path="add-notification" element={<AddNotification />} />
                <Route path="add-card" element={<AddCard />} />
              </Route>
              <Route path="/paci-logs" element={<MainPage />}>
                <Route index path="" element={<PaciLogs />} />
                <Route path="edit-paci/:paciId" element={<EditPaciLog />} />
              </Route>
              <Route path="/slider-screens" element={<MainPage />}>
                <Route index path="" element={<SliderScreen />} />
                <Route
                  index
                  path="add-slider-screen"
                  element={<AddEditSliderScreen />}
                />
                <Route
                  path="add-slider-screen/:sliderId"
                  element={<AddEditSliderScreen />}
                />
              </Route>
              <Route path="/banks" element={<MainPage />}>
                <Route index path="" element={<Banks />} />
                <Route path="add" element={<AddEditBank />} />
              </Route>
              <Route path="/email-templates" element={<MainPage />}>
                <Route index path="" element={<EmailTemplates />} />
                <Route path="add" element={<AddEditEmailTemplate />} />
              </Route>
              <Route path="/rating" element={<MainPage />}>
                <Route index path="" element={<Rating />} />
              </Route>
              <Route path="/subscription" element={<MainPage />}>
                <Route index path="" element={<Subscription />} />
                <Route
                  path="take-action/:subscriptionId"
                  element={<TakeSubscriptionAction />}
                />
              </Route>
              <Route path="/withdrawal" element={<MainPage />}>
                <Route index path="" element={<Withdrawal />} />
                <Route
                  path="take-action/:withdrawalId"
                  element={<TakeWithdrawalAction />}
                />
              </Route>
              <Route path="/cash-transfer" element={<MainPage />}>
                <Route index path="" element={<CashTransfer />} />
                <Route
                  path="take-action/:cashTransferId"
                  element={<TakeCashTransferAction />}
                />
              </Route>
              <Route path="/auto-invest" element={<MainPage />}>
                <Route index path="" element={<AutoInvest />} />
              </Route>
              <Route path="/queries" element={<MainPage />}>
                <Route index path="" element={<Queries />} />
              </Route>
              <Route path="/redemptions" element={<MainPage />}>
                <Route index path="" element={<Redemptions />} />
                <Route
                  path="take-action/:redemptionId"
                  element={<TakeRedemptionsAction />}
                />
              </Route>
              <Route path="/states" element={<MainPage />}>
                <Route path=":countryId" element={<States />} />
              </Route>
              <Route path="/cities" element={<MainPage />}>
                <Route path=":stateId" element={<Cities />} />
              </Route>
              <Route path="/kyc-versions" element={<MainPage />}>
                <Route index path=":accountId" element={<KycVersions />} />
              </Route>
              <Route path="/document-versions" element={<MainPage />}>
                <Route index path=":accountId" element={<DocumentVersions />} />
              </Route>

              <Route path="/account-details" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditAccountDetails />}
                />
                <Route
                  index
                  path=":accountId/:activeKyc/edit-contact-persons"
                  element={<EditContactPersons />}
                />
              </Route>
              <Route path="/document" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<AddEditDocument />}
                />
              </Route>
              <Route path="/professional-details" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditProfesionalDetails />}
                />
              </Route>
              <Route path="/communication-address" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditCommunication />}
                />
              </Route>
              <Route path="/preference" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditPerference />}
                />
              </Route>
              <Route path="/crs" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditCrs />}
                />
              </Route>
              <Route path="/financial" element={<MainPage />}>
                <Route
                  index
                  path=":accountId/:activeKyc/edit"
                  element={<EditFinancial />}
                />
                <Route
                  index
                  path=":accountId/:activeKyc/edit-banks"
                  element={<EditBanks />}
                />
              </Route>
              <Route
                path="/verification-completed"
                element={<VerificationCompleted />}
              />
              <Route
                path="/verification-phone"
                element={<VerificationPassword />}
              />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/something-wrong" element={<SomethingWrong />} />
              <Route path="/knet" element={<Knet />} />
              <Route path="/expire-link" element={<ExpireLink />} />
              <Route path="/backend-users" element={<MainPage />}>
                <Route index path="" element={<BackendUsers />} />
              </Route>
              <Route path="*" element={<Navigate to="/home" />} />
            </>
          )}
        </Routes>
      </div>
    </ConfigProvider>
  );
};
export default App;
